"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = composeEventHandlers;
/**
 * Wraps a lib-defined event handlers returning a single handler that allows
 * a user to prevent other handlers from firing.
 *
 * @param {function} handlers Event handlers executed in order
 * @returns {function} event handler
 */
function composeEventHandlers() {
  for (var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }
  return event => {
    handlers.filter(Boolean).every(h => {
      h(event);
      if (event.defaultPrevented) {
        return false;
      }
      return true;
    });
  };
}